<template>
    <div class="app flex-row align-items-center animated fadeIn">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6">
                    <div class="clearfix">
                        <h1 class="float-left display-3 mr-4">ERRO</h1>
                        <h4 class="pt-3">Problemas na sua requisição!</h4>
                        <p class="text-muted">
                            A página encontra-se indisponível.
                        </p>
                        <b-form-textarea
                            v-model="erro"
                            :rows="8"
                            :readonly="true"
                        >
                        </b-form-textarea>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <b-button variant="info" @click="voltarInicio()"
                            >Voltar para o início</b-button
                        >
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErroPadrao',
    data() {
        return {
            erro: ''
        }
    },

    created() {
        this.$store.dispatch('fecharLoading')
        if (this.$store.getters.requestErro) {
            this.erro = this.$store.getters.requestErro.toString()
        }
    },

    methods: {
        voltarInicio() {
            this.$router.push({ name: 'Home' })
        }
    }
}
</script>
